import React from 'react';
import { withRouter} from 'react-router-dom';
import ReactHelmet from 'react-helmet';
// import CookieConsent, { Cookies } from "react-cookie-consent";
import CookieConsent from "react-cookie-consent";

import LandingLayout from 'component/page/landing';
import Hero from 'component/content/hero';
import About from 'component/content/about';
import CTA from 'component/content/cta';
import Categories from 'component/content/categories';
import How from 'component/content/how';
import SubscribeCTA from 'component/content/subscribe';
// import PricingSection from 'component/content/pricing';

// import Drift from 'react-driftjs'


class Page extends React.Component {
  render (){
    return (
      <LandingLayout id="landing-page">
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>

        <ReactHelmet>
          <script src="https://divshow.bytebeacon.com/sdk/0.0.16/divshow.min.js?show_id=95i1shz4z,ijhsfsqgh"></script>
          {/* <script src="https://divshow.bytebeacon.com/sdk/0.0.14/divshow_builder.min.js?api_key=gdlvrev164"></script> */}

          {/* <script src="http://localhost:3000/sdk/0.0.15/divshow.js?show_id=hiaaxob6y"></script> */}
          {/* <script src="http://localhost:3000/sdk/0.0.15/divshow_builder.js?api_key=vzvlgdz7y8"></script> */}
          {/* <script src="http://localhost:3000/sdk/0.0.11/divshow_builder.min.js?api_key=gdlvrev164"></script> */}
        </ReactHelmet>

        {/* <Drift appId="kswphp4axwf4" /> */}

        <Hero />
        <CTA type="try" />
        <About />
        <How />
        {/* <CTA type="light" content="low"/> */}

        <div className="slant slant-top-right-quaternary-1"></div>
        <div className="content-section gradient-quaternary-1">
        <Categories />
        </div>

        {/* <SubscribeCTA /> */}
        {/* <PricingSection /> */}

      </LandingLayout>
    )
  }
}

export default withRouter(Page);
